<template>
   <div class="container home">
      <div class="container section text-center py-0">
            <div class="container">
               <div class="row justify-content-center">
                  <div class="col-10 mt-0 mb-2 ">
                     <el-carousel height="470px">
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen1.png"  />
                        </el-carousel-item>
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen2.png"  />
                        </el-carousel-item>
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen3.png"  />
                        </el-carousel-item>
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen4.png"  />
                        </el-carousel-item>
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen5.png"  />
                        </el-carousel-item>
                        <el-carousel-item>
                           <img class="d-block" src="img/imagen6.png"  />
                        </el-carousel-item>
                     </el-carousel>
                  </div>
               </div>
            </div>
      </div>
   </div>
</template>
<script>
   import {
      Carousel,
      CarouselItem
   } from 'element-ui';
   export default {
      name: 'home',
      components: {
         [Carousel.name]: Carousel,
         [CarouselItem.name]: CarouselItem
      }
   };
</script>
<style>
   .home {
      min-height: calc(100vh - 300px);
   }
</style>